module.exports = __webpack_public_path__ + "static/media/compona-logo-white.0f542142.svg";